module.exports = function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<ul class="nav nav-tabs ' +
((__t = ( data.stickyNav ? "sticky" : "" )) == null ? '' : __t) +
' ' +
((__t = ( data.newTabButton ? 'has-new-tab-button' : 'no-new-tab-button')) == null ? '' : __t) +
'" role="tablist">\n    ';
 if (data.collapse === true) { ;
__p += '\n    <li class="collapsed_tabs hidden">\n        <a class="btn dropdown-toggle" data-toggle="dropdown" href="#"><i class="far fa-ellipsis-h"></i></a>\n        <ul class="dropdown-menu pull-right all_collapsed_tabs"></ul>\n    </li>\n    ';
 } ;
__p += '\n    ';
 if (data.newTabButton === true) { ;
__p += '\n    <li class="add_tab tooltipped tooltipped-n" aria-label="New tab"><a href="#"><i class="far fa-plus"></i></a></li>\n    ';
 } ;
__p += '\n</ul>\n<div class="tab-content"></div>\n';
return __p
}